module.exports = __webpack_public_path__ + "media/images/games/35gender/longhair-71b0182d7d670c3f88d43ad22a6573de.png";